module.exports = __webpack_public_path__ + "img/logo.dfa60a69.png";